import platformUtils from 'platformUtils'; //eslint-disable-line no-unused-vars
import monitoring from 'privates/monitoring';

platformUtils.setExperiments(self.openExperiments);
platformUtils.initMonitoringServices(self.monitoringServices);
monitoring.initRaven();


// WEBPACK FOOTER //
// ./js/modules/targets/initMonitoring.es6